document.addEventListener('DOMContentLoaded', function() {
  const waitUntil = (ms) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  };

  // Next button functionality
  document.querySelectorAll('.ja-slider__next').forEach(button => {
    button.addEventListener('click', async function() {
      const sliderContainer = this.closest('.ja-slider');
      sliderContainer.classList.add('changing');

      const slidesLen = sliderContainer.querySelectorAll('.ja-slider-item').length;
      const activeSlide = sliderContainer.querySelector('.ja-slider-item.active');
      const activeSlideIndex = Number(activeSlide.dataset.itemIndex);

      const newIndex = activeSlideIndex + 2 > slidesLen ? 0 : activeSlideIndex + 1;

      await waitUntil(300);

      activeSlide.classList.remove('active');

      const activeDot = sliderContainer.querySelector('.ja-slider__dots > .active');
      if (activeDot) activeDot.classList.remove('active');
      
      const targetDot = sliderContainer.querySelector(`.ja-slider__dots > [data-target-index="${newIndex}"]`);
      if (targetDot) targetDot.classList.add('active');

      const targetSlide = sliderContainer.querySelector(`.ja-slider-item[data-item-index="${newIndex}"]`);
      if (targetSlide) targetSlide.classList.add('active');

      await waitUntil(300);
      sliderContainer.classList.remove('changing');
    });
  });

  // Previous button functionality
  document.querySelectorAll('.ja-slider__prev').forEach(button => {
    button.addEventListener('click', async function() {
      const sliderContainer = this.closest('.ja-slider');
      sliderContainer.classList.add('changing');

      const slidesLen = sliderContainer.querySelectorAll('.ja-slider-item').length;
      const activeSlide = sliderContainer.querySelector('.ja-slider-item.active');
      const activeSlideIndex = Number(activeSlide.dataset.itemIndex);

      await waitUntil(300);

      activeSlide.classList.remove('active');

      const newIndex = activeSlideIndex - 1 < 0 ? slidesLen - 1 : activeSlideIndex - 1;

      const activeDot = sliderContainer.querySelector('.ja-slider__dots > .active');
      if (activeDot) activeDot.classList.remove('active');
      
      const targetDot = sliderContainer.querySelector(`.ja-slider__dots > [data-target-index="${newIndex}"]`);
      if (targetDot) targetDot.classList.add('active');

      const targetSlide = sliderContainer.querySelector(`.ja-slider-item[data-item-index="${newIndex}"]`);
      if (targetSlide) targetSlide.classList.add('active');

      await waitUntil(300);
      sliderContainer.classList.remove('changing');
    });
  });

  // Dots functionality
  document.querySelectorAll('.ja-slider__dots > span').forEach(dot => {
    dot.addEventListener('click', async function() {
      const sliderContainer = this.closest('.ja-slider');
      sliderContainer.classList.add('changing');

      const targetIndex = this.dataset.targetIndex;

      await waitUntil(300);

      const activeSlide = sliderContainer.querySelector('.ja-slider-item.active');
      if (activeSlide) activeSlide.classList.remove('active');
      
      const targetSlide = sliderContainer.querySelector(`.ja-slider-item[data-item-index="${targetIndex}"]`);
      if (targetSlide) targetSlide.classList.add('active');

      const activeDot = sliderContainer.querySelector('.ja-slider__dots > .active');
      if (activeDot) activeDot.classList.remove('active');
      
      const targetDot = sliderContainer.querySelector(`.ja-slider__dots > [data-target-index="${targetIndex}"]`);
      if (targetDot) targetDot.classList.add('active');

      await waitUntil(300);
      sliderContainer.classList.remove('changing');
    });
  });

  // Drag and touch support
  document.querySelectorAll('.ja-slider-item').forEach(function(item) {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    const threshold = 5; // Minimum drag distance
    const slider = item.closest('.ja-slider');

    // Mouse and touch start
    const handleStart = function(e) {
      if (item.closest('.ja-slider').classList.contains('changing')) {
        return;
      }
      
      isDragging = true;
      startX = e.type === 'mousedown' ? e.pageX : e.touches[0].pageX;
      currentX = startX;
      
      // Mouse cursor change
      if (e.type === 'mousedown') {
        item.classList.add('grabbing');
        item.style.cursor = 'grabbing';
        e.preventDefault();
      }
      
      // Touch prevention for drag
      if (e.type === 'touchstart') {
        const touch = e.touches[0];
        const touchMoveHandler = (moveEvent) => {
          if (Math.abs(moveEvent.touches[0].pageX - touch.pageX) > 10) {
            e.preventDefault();
            document.removeEventListener('touchmove', touchMoveHandler);
          }
        };
        document.addEventListener('touchmove', touchMoveHandler, { passive: false });
      }
    };

    item.addEventListener('mousedown', handleStart);
    item.addEventListener('touchstart', handleStart, { passive: false });

    // Mouse and touch move
    const handleMove = function(e) {
      if (!isDragging) return;
      e.preventDefault();
      currentX = e.type === 'mousemove' ? e.pageX : e.touches[0].pageX;
    };

    document.addEventListener('mousemove', handleMove, { passive: false });
    document.addEventListener('touchmove', handleMove, { passive: false });

    // Mouse and touch end
    const handleEnd = function(e) {
      if (!isDragging) return;
      
      const diff = currentX - startX;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          const prevButton = slider.querySelector('.ja-slider__prev');
          if (prevButton) prevButton.click();
        } else {
          const nextButton = slider.querySelector('.ja-slider__next');
          if (nextButton) nextButton.click();
        }
      }
      
      isDragging = false;
      document.querySelectorAll('.ja-slider-item').forEach(slideItem => {
        slideItem.classList.remove('grabbing');
        slideItem.style.cursor = '';
      });
    };

    document.addEventListener('mouseup', handleEnd);
    document.addEventListener('touchend', handleEnd);
    document.addEventListener('mouseleave', handleEnd);

    // Prevent default drag and click behaviors
    const handlePreventDefault = function(e) {
      if (isDragging || item.closest('.ja-slider').classList.contains('changing')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    item.addEventListener('dragstart', handlePreventDefault);
    item.addEventListener('click', handlePreventDefault);
  });
});